<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Login</h1>
                  <p class="text-muted" v-if="errorMessage == ''">Sign In to your account</p>
                  <p v-if="errorMessage != ''" style="color:red;">{{errorMessage}}</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="text"
                      class="form-control"
                      placeholder="Username"
                      v-model="form.username"
                      autocomplete="username email"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="password"
                      class="form-control"
                      placeholder="Password"
                      v-model="form.password"
                      autocomplete="current-password"
                      @keyup.enter="loginUser"
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" class="px-4" @click="loginUser">Login</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <!-- <b-button variant="link" class="px-0">Forgot password?</b-button> -->
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card no-body class="aai-login-side text-white bg-primary py-5 d-md-down-none">
              <b-card-body class="text-center">
                <div>
                  <img src="https://crm.aai-live.com/img/aai-logo.png" style="width: 80%;" />
                  <hr />
                  <h3>Administration Module</h3>
                  <p>Registered users can:</p>
                  <ul class="text-left">
                    <li>distribute tests</li>
                    <li>view reports</li>
                    <li>manage sessions</li>
                    <li>enable additional features</li>
                  </ul>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      errorMessage: ''
    };
  },
  name: 'Login',
  methods: {
    ...mapActions('auth', ['login']),
    loginUser() {
      this.login(this.form)
        .then(r => {
          console.log(r);
          this.$router.push('/dashboard');
        })
        .catch(e => {
          if (e.status === 404) {
            this.errorMessage = 'Unknown username and password.';
            return;
          }
          this.errorMessage = 'Internal error';
        });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
